// extracted by mini-css-extract-plugin
export default {"modal":"ExampleEditor_modal__TQyV-","header":"ExampleEditor_header__yzaA1","container":"ExampleEditor_container__G1VwJ","MuiInputBase-root":"ExampleEditor_MuiInputBase-root__jNH1z"};